import { render, staticRenderFns } from "./PromotionSlotsList.vue?vue&type=template&id=3dc448e2&"
import script from "./PromotionSlotsList.vue?vue&type=script&lang=js&"
export * from "./PromotionSlotsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports